import commonConstant from '../../common/_commonConstant';
import { getCookieToken, checkTimeToRefreshToken } from '../../common/_commonFunction';
import { history, userErrorDetail } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetUsers = (buildingRefNo, name, mobilePhone, userRole, sortBy, order, from, to, limit, offset) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users?buildingRefNo=${buildingRefNo}${name ? `&name=${name}` : ''}${mobilePhone ? `&mobilePhone=${mobilePhone}` : ''}${userRole ? `&userRole=${userRole}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}${order ? `&order=${order}` : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}${limit ? `&limit=${limit}` : ''}${offset ? `&offset=${offset}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_USERS_SUCCESS,
          'data': data.data ? data.data : [],
          'metadata': data.metadata ? data.metadata : {},
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_USERS_FAILURE,
        'data': null,
        'metadata': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_USERS_FAILURE,
        'data': null,
        'metadata': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchCreateUser = (buildingID, userRoleID, username, name, mobilePhone, userEmail) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'POST',
        'body': JSON.stringify({ buildingID, userRoleID, username, name, mobilePhone, userEmail }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.CREATE_USER_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401 || res.status === 403) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      } else if (res.status === 400 && (data.detail === commonConstant.trowErrorUsernameAlreadyExist || data.detail === commonConstant.trowErrorUsernameCharacter)) {
        return dispatch({
          'type': commonConstant.CREATE_USER_FAILURE,
          'data': data.detail ? { 'reason': userErrorDetail(data.detail) } : null,
          'status': res.status,
          'detail': data.detail,
          'dateTime': new Date(),
        });
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.CREATE_USER_FAILURE,
        'data': null,
        'status': res.status,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CREATE_USER_FAILURE,
        'data': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchUpdateUser = (userID, name, mobilePhone, userEmail, deletedAt) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users/${userID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'PUT',
        'body': JSON.stringify({ name, mobilePhone, userEmail, deletedAt }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_USER_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401 || res.status === 403) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_USER_FAILURE,
        'data': null,
        'status': res.status,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_USER_FAILURE,
        'data': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchGetUserRoles = () => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/user-roles`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_USER_ROLES_SUCCESS,
          'data': data.data ? data.data : null,
          'status': data.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_USER_ROLES_FAILURE,
        'data': null,
        'status': data.status,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_USER_ROLES_FAILURE,
        'data': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchResetUserPassword = userID => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/users/${userID}/reset-password`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'PATCH',
        'body': JSON.stringify({}),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.RESET_USER_PASSWORD_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.RESET_USER_PASSWORD_FAILURE,
        'data': data ? data : null,
        'status': res.status,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.RESET_USER_PASSWORD_FAILURE,
        'data': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);

export const clearCreateUser = () => (
  async dispatch => {
    try {
      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      return dispatch({
        'type': commonConstant.CLEAR_CREATE_USER_SUCCESS,
        'data': null,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CLEAR_CREATE_USER_FAILURE,
        'data': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);

export const clearUpdateUser = () => (
  async dispatch => {
    try {
      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      return dispatch({
        'type': commonConstant.CLEAR_UPDATE_USER_SUCCESS,
        'data': null,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CLEAR_UPDATE_USER_FAILURE,
        'data': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);

export const clearResetUserPassword = () => (
  async dispatch => {
    try {
      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      return dispatch({
        'type': commonConstant.CLEAR_RESET_USER_PASSWORD_SUCCESS,
        'data': null,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CLEAR_RESET_USER_PASSWORD_FAILURE,
        'data': null,
        'status': err.status,
        'dateTime': new Date(),
      });
    }
  }
);
